import { render } from "./view_client_admin.html?vue&type=template&id=0d5e9ad4&external"
import script from "./view_client_admin.js?vue&type=script&lang=js&external"
export * from "./view_client_admin.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__